import axios from "axios";
import { useEffect, useState } from "react";

export default function Content() {
    const [data, setData] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    const getData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/laporan/get-data`);
            const responseData = response.data.data.data;
            setData(responseData);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    if (loading) return <div className="text-center py-20">Loading...</div>;
    if (!data) return <div className="text-center py-20">Tidak ada data laporan.</div>;

    return (
        <div className="max-w-screen-2xl mx-auto pt-16 pb-60 px-5 lg:px-20">
            {Object.entries(data as Record<string, any[]>).map(([jenisLaporan, daftarLaporan], index) => (
                <div key={index} className="mb-12 border-b pb-6">
                    <h2 className="text-2xl font-bold text-blue-800 mb-6">{jenisLaporan}</h2>
                    {daftarLaporan.map((laporan, i) => (
                        <div key={i} className="mb-6 flex justify-between items-center border-b pb-4">
                            <div>
                                <h3 className="text-lg font-medium text-gray-800">{laporan.title}</h3>
                                <p className="text-sm text-gray-400">{laporan.file.split('.').pop()?.toUpperCase()} Document</p>
                            </div>
                            <a
                                href={`${process.env.REACT_APP_API_ENDPOINT}/laporan/getfile/${laporan.file}`}
                                className="text-sm text-blue-700 hover:underline font-medium"
                                download
                            >
                                Download
                            </a>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
